module.exports = __webpack_public_path__ + "static/media/about-1.2b2af916.jpg";